import axiosClient from "./axiosClient";

export const uploadApi = {
  upload(body) {
    return axiosClient.post("/upload", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
